// AreCoin, Areena's play currency (user decisions 2026-10-01, blackjack-suunnitelma.md). No money value:
// it cannot be bought, sold or exchanged. Registered players only; the balance is seen by the player and
// the administrators.

export interface CoinConfig {
  /** Given once, when the player first uses AreCoin. */
  startBalance: number;
  /** Once a day (Finnish time) a balance below this can be topped up to it. */
  refillTo: number;
}

export const DEFAULT_COIN_CONFIG: CoinConfig = { startBalance: 500, refillTo: 200 };
export const COIN_REASON_MAX = 200;
/** An administrator's single change at most (a typo guard; several changes are possible). */
export const COIN_ADJUST_MAX = 1_000_000_000;

export type CoinKind = 'start' | 'refill' | 'admin' | 'bet' | 'win' | 'refund' | 'reward';

export interface CoinLedgerView {
  id: number;
  amount: number;
  balanceAfter: number;
  kind: CoinKind;
  reason: string;
  game: string | null;
  createdAt: number;
  /** For the administrator's log. */
  user?: string;
  admin?: string | null;
}

export interface CoinMe {
  balance: number;
  refillTo: number;
  /** The daily top-up is available now. */
  canRefill: boolean;
  history: CoinLedgerView[];
}

export interface CoinAccountView {
  userId: number;
  displayName: string;
  username: string;
  /** Null: the player has not used AreCoin yet. */
  balance: number | null;
  lastChange: number | null;
}

/** "1 250" – thin groups as in Finnish. */
export const formatCoins = (n: number) => n.toLocaleString('fi-FI');

/** The day in Finland, "2026-10-01" (the daily top-up). */
export function finnishDay(at = Date.now()): string {
  return new Intl.DateTimeFormat('sv-SE', { timeZone: 'Europe/Helsinki', year: 'numeric', month: '2-digit', day: '2-digit' }).format(at);
}
